import { tv } from 'tailwind-variants'

import { caption, h5 } from '@ui-kit/core/typography'

export const listItem = tv({
  slots: {
    container:
      'flex w-full max-w-list flex-row items-center web:transition web:duration-300 web:ease-in-out',
    imageContainer: 'mr-4 flex items-center justify-center',
    image: 'h-full w-full overflow-hidden rounded-lg object-contain',
    content: 'flex flex-1 flex-row items-center gap-x-4',
    textContainer: 'flex flex-1 flex-col items-start',
    title: h5(),
    subtitle: caption({ emphasis: 'medium', className: 'pt-1' }),
    tagContainer: 'pb-1',
    rightContentContainer: 'flex flex-row items-center',
    iconContainer: 'flex h-6 w-6 items-center justify-end overflow-hidden',
  },
  variants: {
    pressable: {
      true: {
        container:
          'cursor-pointer outline-none hover:bg-ui-grey-50 hover:shadow-md hover:shadow-ui-grey-50 active:bg-ui-grey-50 active:shadow-md active:shadow-ui-grey-50',
      },
    },
    isCompleted: {
      true: { container: 'opacity-60' },
    },
    image: {
      xsmall: {
        imageContainer: 'h-2.5 w-2.5',
      },
      small: {
        imageContainer: 'h-6 w-6',
      },
      medium: {
        imageContainer: 'h-10 w-10',
      },
      large: {
        imageContainer: 'h-16 w-16',
      },
      xlarge: {
        imageContainer: 'h-[104px] w-[104px]',
      },
    },
    bordered: {
      true: {
        content: 'border-b-solid border-b border-b-ui-grey-50',
      },
    },
    lineThrough: {
      true: {
        subtitle: 'line-through',
        title: 'line-through',
      },
    },
    underlinedTitle: {
      true: {
        title: 'underline',
      },
    },
  },
})
